module.exports = __webpack_public_path__ + "static/IMG_2287-bd123fa0a1ca7d23482534f35bf49a63.jpg";